import { render, staticRenderFns } from "./insurance-agreements.vue?vue&type=template&id=1e785ab6"
import script from "./insurance-agreements.vue?vue&type=script&lang=ts"
export * from "./insurance-agreements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports